import React, { useState, useEffect, useMemo } from 'react';
import { number, func } from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { getDateToString, getFormatNumber } from '../../../utils/convert';
import { useEntidad } from '../../hooks/useEntidad';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { PERMISSIONS } from '../../../consts/permissions';
import { usePermissions } from '../../hooks/usePermissions';
import SubTasasModal from '../SubTasasModal';
import CuentaCorrientePartidaGrid from '../CuentaCorrientePartidaGrid';


import { useFormErrors } from '../../hooks/useFormErrors';
import { FormError, Loading, TableCustom, FormLabel } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const CuentaCondonacionModal = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        loading: false,
        showSubTasas: false,
        deudaLoaded: false,
        selectedAll: false,
        showPartida: false,
        numeroPartida: 0
    });

    const [listSubTasas, setListSubTasas] = useState([]);
    const [listDeuda, setListDeuda] = useState([]);
    const [showAccesorios, setShowAccesorios] = useState(false);
    const [columnsAccesorios, setColumnsAccesorios] = useState([]);

    const { hasPermission } = usePermissions();
    const canEditCondonacion = hasPermission(PERMISSIONS.CONDONACION_EDIT);

    const mount = () => {
        setState(prevState => {
            return {...prevState,
                idCuenta: props.idCuenta
            };
        });
    }
    useEffect(mount, [props.idCuenta]);

    const [ formValues, formHandle, , ] = useForm({
        observacion: ""
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa', 'SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        }
    });

    //definiciones
    const getCodigoTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? row.codigo : '';
    }
    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }

    const cellAddSubTasa = () =>  <div className='action'>
                                        <div onClick={ (event) => handleClickAddSubTasa() } className="link">
                                            <span className="material-symbols-outlined" title="Nuevo">add</span>
                                        </div>
                                    </div>;
    const cellRemoveSubTasa = (props) => {
        const row = props.row.original;
        return  <div className='action'>
                    <div onClick={ (event) => handleClickRemoveSubTasa(row.id) } className="link">
                        <span className="material-symbols-outlined" title="Quitar">delete</span>
                    </div>
                </div>;
    }

    const cellSelAll = (props) =>   <div className='action-check'>
                                        <input name="selectedAll" type="checkbox" value={''} className='form-check-input'
                                            checked={ state.selectedAll }
                                            onChange={({target}) =>{
                                                const checked = target.checked;
                                                setState(prevState => ({...prevState, selectedAll: checked}));
                                                SelectAll(checked);
                                            }}
                                        />
                                    </div>

    const cellSel = (props) =>      <div className='action-check'>
                                        <input className='form-check-input' type="checkbox" value={''} checked={ listDeuda[props.value].selected } readOnly={true} />
                                    </div>

    const cellAcc = (props) =>      <div className='action'>
                                        Accesorios
                                        <div onClick={ (event) => handleClickItemToggleAccesorios() } className="link">
                                        {(showAccesorios) ?
                                            <span className="material-symbols-outlined" title="Ocultar detalle de accesorios">check_indeterminate_small</span>
                                            :
                                            <span className="material-symbols-outlined" title="Mostrar detalle de accesorios">add</span>
                                        }
                                        </div>
                                    </div>

    const cellVMR = (props) =>      <div className='action'>
                                        <div onClick={ (event) => handleClickPartidaView(listDeuda[props.value].numeroPartida) } className="link">
                                            <span className="material-symbols-outlined" title="ver partida">search</span>
                                        </div>
                                    </div>

    const GetFooterTotalSelected = (info, columnName) => {
        const total = useMemo(
            () =>
            info.rows.reduce((sum, row) => (row.original.selected ? row.values[columnName] + sum : sum), 0),
            [info.rows]
        )

        return <>{getFormatNumber(total,2)}</>
    }

    const tableColumnsSubTasas = [
        { Header: 'Tasa', Cell: (props) => getDescTasa(props.value), accessor: 'idTasa', width: '40%', disableSortBy: true },
        { Header: 'Sub tasa', Cell: (props) => `${props.row.original.codigo} - ${props.row.original.descripcion}`, id: 'subTasa', accessor: 'id', width: '50%', disableSortBy: true },
        { Header: cellAddSubTasa, Cell: cellRemoveSubTasa, id: 'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ];

    useEffect(() => {
        const columns = (showAccesorios) ? [
            { Header: 'Multas', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMultas', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Recargos', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeRecargos', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Causídicos', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMayorC', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Honorarios', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeMayorA', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
            { Header: 'Aportes', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'importeAportes', width: '5%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        ] : [];
        setColumnsAccesorios(columns);
    }, [showAccesorios])

    const tableColumnsDeuda = [
        { Header: cellSelAll, Cell: cellSel, accessor: 'index', width:'3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false},
        { Header: 'Tasa', accessor: 'codigoTasa', width: '9%', disableSortBy: true, ellipsis: false},
        { Header: 'Sub tasa', accessor: 'descSubTasa', width: '26%', disableSortBy: true},
        { Header: 'Período', accessor: 'periodo', width: '6%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Cuota', accessor: 'cuota', width: '6%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Importe', Footer: (info) => GetFooterTotalSelected(info ,'importeSaldo'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeSaldo', accessor: 'importeSaldo', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: cellAcc, Footer: (info) => GetFooterTotalSelected(info ,'importeAccesorios'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeAccesorios', accessor: 'importeAccesorios', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        ...columnsAccesorios,
        { Header: 'Total', Footer: (info) => GetFooterTotalSelected(info ,'importeTotal'), Cell: (props) => getFormatNumber(props.value, 2), id: 'importeTotal', accessor: 'importeTotal', width: '8%', alignCell: 'right', disableSortBy: true, ellipsis: false},
        { Header: 'Vto.', Cell: (props) => (props.value) ? getDateToString(props.value, false) : '', accessor: 'fechaVencimiento2', width: '6%', disableSortBy: true, ellipsis: false},
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'index', width: '3%', disableGlobalFilter: true, disableSortBy: true, ellipsis: false}
    ];


    // handlers
    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickAddSubTasa = () => {
        setState(prevState => {
            return {...prevState, showSubTasas: true};
        });
    }
    const handleClickRemoveSubTasa = (id) => {
        setListSubTasas(prevState => prevState.filter(f => f.id !== id));
    }
    const handleClickListarDeuda = () => {
        if (isFormValidListarDeuda()) {
            SearchCondonacionDeuda();
        }
    }
    const handleClickCancelar = () => {
        setListDeuda([]);
        setListSubTasas([]);
        setState(prevState => {
            return {...prevState, deudaLoaded: false, selectedAll: false};
        });
    }
    const handleClickConfirmar = () => {
        if (isFormValidConfirmar()) {
            AddCondonacion();
        }
    }
    const handleClickItemToggleAccesorios = () => {
        setShowAccesorios(!showAccesorios);
    }
    const handleClickPartidaView = (numeroPartida) => {
        setState(prevState => {
            return {...prevState, showPartida: true, numeroPartida: numeroPartida};
        });
    }
    const handleClickSelected = (index) => {
        const list = [...listDeuda];
        list[index].selected = !list[index].selected;
        UpdateListDeuda(list);
    }
    //callbacks
    const onConfirmMultipleSubTasas = (subTasas) => {
        const result = [...listSubTasas];
        let agregadas = 0;

        subTasas.forEach(subTasa => {
            if (!result.find(f => f.id === subTasa.id)) {
                result.push(subTasa);
                agregadas++;
            }
        });

        setListSubTasas(result);
        setState(prevState => {
            return {...prevState, showSubTasas: false};
        });

        if (agregadas === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Las sub tasas seleccionadas ya estaban en el listado');
        }
    }
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessSearchCondonacionDeuda = (response) => {
        response.json()
        .then((data) => {
            const items = [...data];

            items.forEach((item, index) => {
                if (item.fechaMovimiento) item.fechaMovimiento = new Date(item.fechaMovimiento);
                if (item.fechaVencimiento1) item.fechaVencimiento1 = new Date(item.fechaVencimiento1);
                if (item.fechaVencimiento2) item.fechaVencimiento2 = new Date(item.fechaVencimiento2);

                item.codigoTasa = getCodigoTasa(item.idTasa);
                item.descTasa = getDescTasa(item.idTasa);
                item.descSubTasa = getDescSubTasa(item.idSubTasa);
                item.index = index;
                item.selected = false;
            });

            setListDeuda(items);
            setState(prevState => {
                return {...prevState, loading: false, deudaLoaded: true, selectedAll: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessAddCondonacion = (response) => {
        response.json()
        .then((data) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La condonación fue realizada correctamente", () => {
                if (props.onClickVolver) props.onClickVolver();
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }

    //funciones
    function isFormValidListarDeuda() {

        if (listSubTasas.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar al menos una tasa / sub tasa');
            return false;
        }

        return true;
    }
    function getErrors() {

        const errors = {};

        if (formValues.observacion.length <= 0) errors.observacion = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    function isFormValidConfirmar() {

        if (!validate()) {
            return false;
        }

        if (listSubTasas.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar al menos una tasa / sub tasa');
            return false;
        }

        if (!listDeuda.some(f => f.selected)) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe seleccionar al menos una partida');
            return false;
        }

        return true;
    }
    function SelectAll(checked) {
        const list = [...listDeuda];
        for (let index=0; index < list.length; index++) {
            list[index].selected = checked;
        }
        setListDeuda(list);
    }
    function UpdateListDeuda(list) {
        setState(prevState => ({...prevState, selectedAll: false}));
        setListDeuda(list);
    }
    function SearchCondonacionDeuda() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/condonacion-deuda/${state.idCuenta}`;
        const dataBody = {
            idsSubTasa: listSubTasas.map(f => f.id)
        };

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessSearchCondonacionDeuda,
            callbackNoSuccess,
            callbackError
        );

    }
    function AddCondonacion() {
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const paramsUrl = `/condonacion/${state.idCuenta}`;
        const dataBody = {
            idsSubTasa: listSubTasas.map(f => f.id),
            partidas: listDeuda.filter(f => f.selected).map(f => f.numeroPartida),
            observacion: formValues.observacion
        };

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.CUENTA_CORRIENTE_ITEM,
            paramsUrl,
            dataBody,
            callbackSuccessAddCondonacion,
            callbackNoSuccess,
            callbackError
        );
    }

    return (
    <>

        <Loading visible={state.loading}></Loading>

        {state.showSubTasas &&
            <SubTasasModal
                multiple={true}
                onDismiss={() => setState(prevState => ({...prevState, showSubTasas: false}))}
                onConfirmMultiple={onConfirmMultipleSubTasas}
            />
        }

        {state.showPartida &&
            <CuentaCorrientePartidaGrid
                data={{
                    idCuenta: props.idCuenta,
                    idTipoTributo: props.idTipoTributo,
                    numeroPartida: state.numeroPartida
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showPartida: false, numeroPartida: 0};
                    });
                }}
            />
        }

        <div className="row">

            <div className="mb-3 col-12">
                <FormLabel htmlFor="observacion" required>Observación</FormLabel>
                <input
                    name="observacion"
                    type="text"
                    placeholder=""
                    className={`form-control ${errorOf('observacion') ? 'is-invalid' : ''}`}
                    value={ formValues.observacion }
                    onChange={ formHandle }
                />
                <FormError message={errorOf('observacion')} />
            </div>

            <div className="mb-3 col-12 m-top-20">

                <label className="form-label label-subtitle">Tasas / Sub tasas a condonar</label>
                <TableCustom
                    className={'TableCustomBase'}
                    columns={tableColumnsSubTasas}
                    data={listSubTasas}
                />

            </div>

            <div className="mb-3 col-12 m-top-20">

                <div className="row">
                    <label className="form-label label-subtitle col-12 col-md-8 align-self-center">Deuda a condonar</label>
                    <div className="col-12 col-md-4 p-bottom-5">
                        <button className="btn action-button float-end" onClick={ (event) => handleClickListarDeuda() } >Listar Deuda</button>
                    </div>
                </div>

                {state.deudaLoaded &&
                    <TableCustom
                        showFooter={true}
                        className={'TableCustomBase'}
                        columns={tableColumnsDeuda}
                        data={listDeuda}
                        onClickRow={(row, cellId) => {
                            if (cellId !== "abm") {
                                handleClickSelected(row.index);
                            }
                        }}
                    />
                }

            </div>

            <div className="col-12 m-top-50">
                {props.onClickVolver && (
                    <button className="btn back-button" data-dismiss="modal" onClick={props.onClickVolver}>Volver</button>
                )}
                {state.deudaLoaded && canEditCondonacion &&
                    <button className="btn action-button float-end m-left-10" onClick={ (event) => handleClickConfirmar() } >Confirmar</button>
                }
                {state.deudaLoaded &&
                    <button className="btn action-button float-end" onClick={ (event) => handleClickCancelar() } >Cancelar</button>
                }
            </div>

        </div>

    </>
    );
}

CuentaCondonacionModal.propTypes = {
    idCuenta: number.isRequired,
    idTipoTributo: number.isRequired,
    onClickVolver: func
};

export default CuentaCondonacionModal;
